// extracted by mini-css-extract-plugin
module.exports = {"usageStats":"DataPointVisualization-module__usageStats___2oQ_E"};